import URL from '../api_url';

export const CALENDAR_API = `${URL}/calendar`;

export const CALENDARS_API = `${URL}/calendars`;